import { createNode } from '@glueapp/graph-types';

export const ManualTrigger = createNode({
    isAsync: false,
    id: 'Manual Trigger',
    name: 'Manual Trigger (DEPRECATED)',
    description: '',
    aiDescription: 'Deprecated trigger that fires on manual click and outputs a random number. Use Webhook or Schedule instead.',
    category: 'Trigger',
    color: '#808080',
    inPorts: {},
    findableInLibrary: false,
    outPorts: { 'Random Number': { kind: 'number' } },
    triggerEventIdentifier: 'manualClickInInterface',
    execute: function () {
        return { output: { 'Random Number': Math.random() } };
    },
});
